export const MiniHeader = ({
  header,
  subheader,
  className = "",
}: {
  header: string;
  subheader?: string;
  className?: string;
}) => {
  return (
    <>
      <p className={`text-base font-bold text-grey-950 ${className}`}>
        {header}
      </p>
      {subheader && <p className="text-sm text-grey-500">{subheader}</p>}
    </>
  );
};
